import { render } from "./DrinkLista.vue?vue&type=template&id=e660f29c"
import script from "./DrinkLista.vue?vue&type=script&lang=js"
export * from "./DrinkLista.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__